module.exports = __webpack_public_path__ + "img/logo-1.23eb75b4.svg";